import AWS from 'aws-sdk'
import connectionClass from 'http-aws-es'
import elasticsearch from 'elasticsearch'

let instance

export const getAwsEsClient = () => {
	if (instance) {
		return instance
	}

	instance = new elasticsearch.Client({
		host: window.appConfig._$fjopvt,
		log: 'error',
		connectionClass: connectionClass,
		amazonES: {
			credentials: AWS.config.credentials
		}
	})

	return instance
}



// WEBPACK FOOTER //
// ./src/services/aws_es_client.js